import { FormActions } from "../../components/common/FormActions";
import { StatusTag } from "../../components/common/registerUtils";
import { createViewAction, formatDateTime } from "../../utils/helpers";
import { URL_IFRAME_PAYMENTS } from "../../utils/urls";

const url = URL_IFRAME_PAYMENTS;

// REGISTER
export const useIframePayments = () => {
  const tableColumns = () => [
    {
      id: "phone_number",
      header: "Phone Number",
      filter: {},
    },
    {
      id: "amount",
      header: "Amount",
    },
    {
      id: "reference",
      header: "Reference",
      filter: {},
    },
    {
      id: "is_service_payment",
      header: "Is Service Payment",
      filter: {},
    },
    {
      id: "service",
      header: "Service",
      filter: {},
    },
    {
      id: "processed",
      header: "Processed",
      filter: {},
    },
    {
      id: "status",
      header: "Status",
      filter: {
        type: "text",
      },
    },
    {
      id: "created_at",
      header: "Created At",
      filter: {
        type: "date",
      },
    },
    { id: "actions", header: "Actions" },
  ];

  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      return {
        ...item,
        status: <StatusTag status={item?.status} />,
        created_at: formatDateTime(item?.created_at),
        actions: <FormActions actions={[createViewAction(url, item?.id)]} />,
      };
    }),
  ];

  const viewData = (item: any) => {
    return {
      sections: [
        {
          title: "Iframe Payments Details",
          fields: {
            ...item,
            status: <StatusTag status={item?.status} />,
            created_at: formatDateTime(item?.created_at),
          },
        },
      ],
    };
  };

  return { tableData, tableColumns, viewData };
};
